import React from 'react';
import PropTypes from 'prop-types';
import { STATISTICS_BY_CHANNEL } from './consts';
import { StatLabel, StatValue, StatsWrapper, StatWrapper } from './style';

const Stat = ({ statLabel, value }) => {
  const isSingularValue = value === 1;
  const parsedLabel = isSingularValue
    ? statLabel.singularLabel
    : statLabel.pluralLabel;

  return (
    <StatWrapper>
      <StatLabel color="shuttleGray" size="mini">
        {parsedLabel}
      </StatLabel>
      <StatValue weight="bold" color="black">
        {value || 0}
      </StatValue>
    </StatWrapper>
  );
};

const Analytics = ({ statistics, service }) => {
  const statisticsFromService = STATISTICS_BY_CHANNEL[service];

  return (
    <StatsWrapper>
      {Object.keys(statisticsFromService).map((stat) => {
        return (
          <Stat
            statLabel={statisticsFromService[stat]}
            value={statistics[stat] || 0}
            key={stat}
          />
        );
      })}
    </StatsWrapper>
  );
};

Stat.propTypes = {
  statLabel: PropTypes.shape({
    singularLabel: PropTypes.string.isRequired,
    pluralLabel: PropTypes.string.isRequired,
  }).isRequired,
  value: PropTypes.number.isRequired,
};

Analytics.propTypes = {
  statistics: PropTypes.shape({
    favorites: PropTypes.number,
    mentions: PropTypes.number,
    retweets: PropTypes.number,
    reach_twitter: PropTypes.number,
    clicks: PropTypes.number,
    comments: PropTypes.number,
    likes: PropTypes.number,
    reach: PropTypes.number,
    shares: PropTypes.number,
    reshares: PropTypes.number,
    repins: PropTypes.number,
    linkClicks: PropTypes.number,
    views: PropTypes.number,
  }),
  service: PropTypes.string.isRequired,
};

Analytics.defaultProps = {
  statistics: {},
};

export default Analytics;
